<template>
  <div class="WxUserCard">
    <mu-container style="padding: 16px 0;">
      <mu-row justify-content="center">
        <mu-avatar size="100">
          <img :src="avatar">
        </mu-avatar>
      </mu-row>
      <div class="nickname">
        {{ nickname }}
      </div>

      <div class="LogoutBtn">
        <mu-button color="primary" @click="Logout">退出</mu-button>
      </div>
    </mu-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { WxUserLogout } from '@/api/all'
import Toast from 'muse-ui-toast'
export default {
  name: 'WxUserCard',
  computed: {
    ...mapGetters([
      'nickname',
      'avatar'
    ])
  },
  methods: {
    Logout: function() {
      WxUserLogout().then(res => {
        if (res.error !== 0) {
          Toast.error(res.msg)
          this.$store.dispatch('removeWxToken')
          this.$store.dispatch('removeWxUserInfo')
        } else {
          Toast.success(res.msg)
          this.$store.dispatch('removeWxToken')
          this.$store.dispatch('removeWxUserInfo')
        }
      })
    }
  }
}
</script>

<style scoped>
.WxUserCard{
  margin-top: 50px;
}
.nickname{
  margin-top: 20px;
  font-size: 20px;
  text-align: center;
}
.LogoutBtn{
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Login/components/WxUserCard.vue